import React from 'react';
import { Box, Typography } from '@mui/material';
import CardAlertContainer from 'shared/components/alert-card/alert-card.component';

const Unavailable = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '352px',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <CardAlertContainer
        severity='error'
        mainText='Sorry, testing of the Sorenson for Zoom service is currently unavailable while we make updates.'
      />
      <Box id='unavailable-page' sx={{ textAlign: 'left', width: '80%' }}>
        <Typography sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
          You can still get an interpreter in your Zoom meeting!
        </Typography>
        <ul>
          <li style={{ marginBottom: '6px' }}>Connect to Sorenson VRS</li>
          <li style={{ marginBottom: '6px' }}>
            Give the interpreter the Zoom audio number for your meeting
          </li>
          <li>Both you and the interpreter can join your Zoom meeting</li>
        </ul>
      </Box>
    </Box>
  );
};

export default Unavailable;
